import { Dispatch, SetStateAction } from 'react';
import FetchData from '../../../ServerCall/FetchData';
import { GeoJSON } from '../Components/MapCommonComponents';
import { getGeoJSONDB, storeGeoJSONDB } from './GeoJSONDatabase';

// import worldJSON from './WorldData.json';
// import map_JSON from './map.json';

let cachedDefaultMapPromise: Promise<GeoJSON> | null = null;

export const getDefaultMap = async (): Promise<GeoJSON> => {
  if (!cachedDefaultMapPromise) {
    cachedDefaultMapPromise = import('./map.json').then((module) => module.default as GeoJSON);
  }

  return cachedDefaultMapPromise;
};

export const FetchGeoJSON = async (name: string, region: string, detail: string) => {
  try {
    const response = await FetchData({
      checkToken: window.location.href.includes('dashboard') ? false : true,
      requestType: 'noData',
      method: 'GET',
      url: `geo-map?region=${region}&name=${name}&detail=${detail}`,
      headers: {
        // Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    if (response.data === 'No Data Found') {
      return await getDefaultMap(); //Default GeoJSON
    }
    return response.data;
  } catch (error) {
    return await getDefaultMap(); //Fallback
  }
};

export const getGeoJSON = async (name: string, setLoading: Dispatch<SetStateAction<boolean>>) => {
  const cachedGeoJSON = await getGeoJSONDB(name.toLowerCase());
  if (cachedGeoJSON) {
    return cachedGeoJSON.data;
  }

  setLoading(true);

  try {
    switch (name.toLowerCase()) {
      case 'usa': {
        const module = await FetchGeoJSON('us', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'world': {
        return await getDefaultMap();
      }
      case 'india': {
        // const module = await import('./indiaMapData.json');
        const module = await FetchGeoJSON('india', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'argentina': {
        const module = await FetchGeoJSON('argentina', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'brazil': {
        const module = await FetchGeoJSON('brazil', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'belgium': {
        const module = await FetchGeoJSON('belgium', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'canada': {
        const module = await FetchGeoJSON('canada', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'austria': {
        const module = await FetchGeoJSON('austria', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'mexico': {
        const module = await FetchGeoJSON('mexico', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'malaysia': {
        const module = await FetchGeoJSON('malaysia', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'norway': {
        const module = await FetchGeoJSON('norway', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'philippines': {
        const module = await FetchGeoJSON('philippines', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'poland': {
        const module = await FetchGeoJSON('poland', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'russia': {
        const module = await FetchGeoJSON('russia', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'saudi arabia': {
        const module = await FetchGeoJSON('saudiarabia', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'south korea': {
        const module = await FetchGeoJSON('southkorea', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'spain': {
        const module = await FetchGeoJSON('spain', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'switzerland': {
        const module = await FetchGeoJSON('switzerland', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'sweden': {
        const module = await FetchGeoJSON('sweden', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'turkey': {
        const module = await FetchGeoJSON('turkey', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'thailand': {
        const module = await FetchGeoJSON('thailand', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'china': {
        const module = await FetchGeoJSON('china', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'france': {
        const module = await FetchGeoJSON('france', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'germany': {
        const module = await FetchGeoJSON('germany', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'nigeria': {
        const module = await FetchGeoJSON('nigeria', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'japan': {
        const module = await FetchGeoJSON('japan', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'australia': {
        const module = await FetchGeoJSON('australia', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'south africa': {
        const module = await FetchGeoJSON('southafrica', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      // case 'spain': {
      //   const module = await FetchGeoJSON('spain', 'world', 'country');
      //   await storeGeoJSONDB(name.toLowerCase(), module);
      //   return module;
      // }
      case 'singapore': {
        const module = await FetchGeoJSON('singapore', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'uk': {
        const module = await FetchGeoJSON('uk', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'uae': {
        const module = await FetchGeoJSON('uae', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'italy': {
        const module = await FetchGeoJSON('italy', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'ireland': {
        const module = await FetchGeoJSON('ireland', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'indonesia': {
        const module = await FetchGeoJSON('indonesia', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'israel': {
        const module = await FetchGeoJSON('israel', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'vietnam': {
        const module = await FetchGeoJSON('vietnam', 'world', 'country');
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'india cities':
      case 'indian cities': {
        const baseModule = await FetchGeoJSON('india', 'world', 'country');
        const cityModule = await FetchGeoJSON('india', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'usacities':
      case 'usa cities': {
        const baseModule = await FetchGeoJSON('us', 'world', 'country');
        const cityModule = await FetchGeoJSON('us', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'argentinacities':
      case 'argentina cities': {
        const baseModule = await FetchGeoJSON('argentina', 'world', 'country');
        const cityModule = await FetchGeoJSON('argentina', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'australiacities':
      case 'australia cities': {
        const baseModule = await FetchGeoJSON('australia', 'world', 'country');
        const cityModule = await FetchGeoJSON('australia', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'austriacities':
      case 'austria cities': {
        const baseModule = await FetchGeoJSON('austria', 'world', 'country');
        const cityModule = await FetchGeoJSON('austria', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'brazilcities':
      case 'brazil cities': {
        const baseModule = await FetchGeoJSON('brazil', 'world', 'country');
        const cityModule = await FetchGeoJSON('brazil', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'belgiumcities':
      case 'belgium cities': {
        const baseModule = await FetchGeoJSON('belgium', 'world', 'country');
        const cityModule = await FetchGeoJSON('belgium', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'canadacities':
      case 'canada cities': {
        const baseModule = await FetchGeoJSON('canada', 'world', 'country');
        const cityModule = await FetchGeoJSON('canada', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'norwaycities':
      case 'norway cities': {
        const baseModule = await FetchGeoJSON('norway', 'world', 'country');
        const cityModule = await FetchGeoJSON('norway', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'chinacities':
      case 'china cities': {
        const baseModule = await FetchGeoJSON('china', 'world', 'country');
        const cityModule = await FetchGeoJSON('china', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      // case 'chinacities':
      // case 'china cities':{
      //   const baseModule = await import('./WorldData.json');
      //   const cityModule = await import('./WorldData.json');
      //   return  {
      //     type: 'FeatureCollection',
      //     features: [
      //       ...(baseModule as GeoJSON)?.features, // base polygon features (states or whole country)
      //       ...(cityModule as GeoJSON)?.features, // city point features
      //     ]
      //   };
      // }
      case 'francecities':
      case 'france cities': {
        const baseModule = await FetchGeoJSON('france', 'world', 'country');
        const cityModule = await FetchGeoJSON('france', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'germanycities':
      case 'germany cities': {
        const baseModule = await FetchGeoJSON('germany', 'world', 'country');
        const cityModule = await FetchGeoJSON('germany', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'irelandcities':
      case 'ireland cities': {
        const baseModule = await FetchGeoJSON('ireland', 'world', 'country');
        const cityModule = await FetchGeoJSON('ireland', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'israelcities':
      case 'israel cities': {
        const baseModule = await FetchGeoJSON('israel', 'world', 'country');
        const cityModule = await FetchGeoJSON('israel', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'italycities':
      case 'italy cities': {
        const baseModule = await FetchGeoJSON('italy', 'world', 'country');
        const cityModule = await FetchGeoJSON('italy', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'indonesiacities':
      case 'indonesia cities': {
        const baseModule = await FetchGeoJSON('indonesia', 'world', 'country');
        const cityModule = await FetchGeoJSON('indonesia', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'japancities':
      case 'japan cities': {
        const baseModule = await FetchGeoJSON('japan', 'world', 'country');
        const cityModule = await FetchGeoJSON('japan', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'malaysiacities':
      case 'malaysia cities': {
        const baseModule = await FetchGeoJSON('malaysia', 'world', 'country');
        const cityModule = await FetchGeoJSON('malaysia', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'mexicocities':
      case 'mexico cities': {
        const baseModule = await FetchGeoJSON('mexico', 'world', 'country');
        const cityModule = await FetchGeoJSON('mexico', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'nigeriacities':
      case 'nigeria cities': {
        const baseModule = await FetchGeoJSON('nigeria', 'world', 'country');
        const cityModule = await FetchGeoJSON('nigeria', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'polandcities':
      case 'poland cities': {
        const baseModule = await FetchGeoJSON('poland', 'world', 'country');
        const cityModule = await FetchGeoJSON('poland', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'philippinescities':
      case 'philippines cities': {
        const baseModule = await FetchGeoJSON('philippines', 'world', 'country');
        const cityModule = await FetchGeoJSON('philippines', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'switzerlandcities':
      case 'switzerland cities': {
        const baseModule = await FetchGeoJSON('switzerland', 'world', 'country');
        const cityModule = await FetchGeoJSON('switzerland', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'thailandcities':
      case 'thailand cities': {
        const baseModule = await FetchGeoJSON('thailand', 'world', 'country');
        const cityModule = await FetchGeoJSON('thailand', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'turkeycities':
      case 'turkey cities': {
        const baseModule = await FetchGeoJSON('turkey', 'world', 'country');
        const cityModule = await FetchGeoJSON('turkey', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'southafricacities':
      case 'south africa cities': {
        const baseModule = await FetchGeoJSON('southafrica', 'world', 'country');
        const cityModule = await FetchGeoJSON('southafrica', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'southakoreacities':
      case 'south korea cities': {
        const baseModule = await FetchGeoJSON('southkorea', 'world', 'country');
        const cityModule = await FetchGeoJSON('southkorea', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'singaporecities':
      case 'singapore cities': {
        const baseModule = await FetchGeoJSON('singapore', 'world', 'country');
        const cityModule = await FetchGeoJSON('singapore', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'saudiarabiacities':
      case 'saudi arabia cities': {
        const baseModule = await FetchGeoJSON('saudiarabia', 'world', 'country');
        const cityModule = await FetchGeoJSON('saudiarabia', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'spaincities':
      case 'spain cities': {
        const baseModule = await FetchGeoJSON('spain', 'world', 'country');
        const cityModule = await FetchGeoJSON('spain', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'swedencities':
      case 'sweden cities': {
        const baseModule = await FetchGeoJSON('sweden', 'world', 'country');
        const cityModule = await FetchGeoJSON('sweden', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'vietnamcities':
      case 'vietnam cities': {
        const baseModule = await FetchGeoJSON('vietnam', 'world', 'country');
        const cityModule = await FetchGeoJSON('vietnam', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'russiacities':
      case 'russia cities': {
        const baseModule = await FetchGeoJSON('russia', 'world', 'country');
        const cityModule = await FetchGeoJSON('russia', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'uaecities':
      case 'uae cities': {
        const baseModule = await FetchGeoJSON('uae', 'world', 'country');
        const cityModule = await FetchGeoJSON('uae', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      case 'ukcities':
      case 'uk cities': {
        const baseModule = await FetchGeoJSON('uk', 'world', 'country');
        const cityModule = await FetchGeoJSON('uk', 'country', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }

      case 'worldcities':
      case 'world cities': {
        // const baseModule = await FetchGeoJSON('world', 'world', 'country');
        const baseModule = await getDefaultMap();
        const cityModule = await FetchGeoJSON('world', 'world', 'city');

        const module = {
          base: baseModule, // polygon data
          cities: cityModule, // city point data
        };
        await storeGeoJSONDB(name.toLowerCase(), module);
        return module;
      }
      default:
        return await getDefaultMap(); // Fallback to default map if no match found
    }
  } catch (error) {
    console.error('Map load error:', error);
    return await getDefaultMap();
  } finally {
    setLoading(false);
  }
};

export const getMismachedLocationArray = (
  chartData: any,
  columnName: string,
  mapJSONName: any,
  matchType: string,
  mapJSON?: GeoJSON,
) => {
  let misMatchArray: any = [];

  chartData.forEach((data: any) => {
    let isMatched = false;

    const chartName = data?.[columnName];

    mapJSON?.features?.forEach((feature: any) => {
      const mapName = feature.properties?.[matchType];
      if (
        // feature.geometry?.type === 'Point' &&
        typeof mapName === 'string' &&
        typeof chartName === 'string' &&
        mapName.toLowerCase() === chartName.toLowerCase()
      ) {
        isMatched = true;
      }
    });

    if (!isMatched && !misMatchArray.some((item: any) => item[columnName] === data[columnName])) {
      data.selectedKey = '';
      misMatchArray.push(data);
    }
  });
  return misMatchArray;
};
